/* ATN Business Opportunities - shared mobile slider
   Turns any CSS grid into a scroll-snap slider below a breakpoint.
   Markup contract:
     [data-atn-mslider]        root element
       [data-mslider-track]    the grid/track element
       [data-mslider-slide]    each item (optionally data-block-id)
       [data-mslider-prev]     previous arrow button (optional)
       [data-mslider-next]     next arrow button (optional)
       [data-mslider-dots]     empty container for dots (optional)
   Root data attributes:
     data-mslider-bp="749"     max-width at which the slider turns on
     data-mslider-loop="true"  wrap around at the edges
*/
(function () {
  'use strict';

  if (window.atnBoMSlider) {
    window.atnBoMSlider.refresh();
    return;
  }

  var ROOT_SELECTOR = '[data-atn-mslider]';
  var instances = [];

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function Slider(root) {
    this.root = root;
    this.track = root.querySelector('[data-mslider-track]');
    this.slides = toArray(root.querySelectorAll('[data-mslider-slide]'));
    this.prev = root.querySelector('[data-mslider-prev]');
    this.next = root.querySelector('[data-mslider-next]');
    this.dotsWrap = root.querySelector('[data-mslider-dots]');
    this.dots = [];
    this.index = 0;
    this.active = false;
    this.ticking = false;

    if (!this.track || this.slides.length === 0) return;

    var bp = parseInt(root.getAttribute('data-mslider-bp'), 10);
    this.bp = isNaN(bp) ? 749 : bp;
    this.loop = root.getAttribute('data-mslider-loop') === 'true';
    this.mq = window.matchMedia('(max-width: ' + this.bp + 'px)');

    this.onScroll = this.handleScroll.bind(this);
    this.onResize = this.evaluate.bind(this);

    if (this.prev) {
      this.prev.addEventListener('click', this.step.bind(this, -1));
    }
    if (this.next) {
      this.next.addEventListener('click', this.step.bind(this, 1));
    }

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.onResize);
    } else if (this.mq.addListener) {
      this.mq.addListener(this.onResize);
    }

    root.setAttribute('data-mslider-init', 'true');
    this.evaluate();
  }

  Slider.prototype.evaluate = function () {
    var shouldRun = this.mq.matches && this.slides.length > 1;
    if (shouldRun === this.active) {
      if (shouldRun) this.update();
      return;
    }
    this.active = shouldRun;
    if (shouldRun) {
      this.enable();
    } else {
      this.disable();
    }
  };

  Slider.prototype.enable = function () {
    this.root.classList.add('is-mslider');
    this.buildDots();
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.index = 0;
    this.track.scrollLeft = 0;
    this.update();
  };

  Slider.prototype.disable = function () {
    this.root.classList.remove('is-mslider');
    this.track.removeEventListener('scroll', this.onScroll);
    this.track.scrollLeft = 0;
    if (this.dotsWrap) this.dotsWrap.innerHTML = '';
    this.dots = [];
  };

  Slider.prototype.buildDots = function () {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    this.dots = [];
    var self = this;
    this.slides.forEach(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'atn-ms-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        self.goTo(i);
      });
      self.dotsWrap.appendChild(dot);
      self.dots.push(dot);
    });
  };

  Slider.prototype.handleScroll = function () {
    if (this.ticking) return;
    this.ticking = true;
    var self = this;
    window.requestAnimationFrame(function () {
      self.ticking = false;
      self.readIndex();
      self.update();
    });
  };

  Slider.prototype.readIndex = function () {
    var left = this.track.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    var base = this.slides[0].offsetLeft;
    for (var i = 0; i < this.slides.length; i++) {
      var dist = Math.abs(this.slides[i].offsetLeft - base - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    this.index = best;
  };

  Slider.prototype.goTo = function (i) {
    if (!this.active) return;
    var max = this.slides.length - 1;
    if (i < 0) i = this.loop ? max : 0;
    if (i > max) i = this.loop ? 0 : max;
    this.index = i;
    var base = this.slides[0].offsetLeft;
    this.track.scrollTo({ left: this.slides[i].offsetLeft - base, behavior: 'smooth' });
    this.update();
  };

  Slider.prototype.step = function (dir, event) {
    if (event) event.preventDefault();
    this.goTo(this.index + dir);
  };

  Slider.prototype.update = function () {
    for (var i = 0; i < this.dots.length; i++) {
      this.dots[i].classList.toggle('is-active', i === this.index);
    }
    if (this.loop) return;
    if (this.prev) this.prev.classList.toggle('is-disabled', this.index === 0);
    if (this.next) this.next.classList.toggle('is-disabled', this.index === this.slides.length - 1);
  };

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    toArray(context.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      if (root.getAttribute('data-mslider-init') === 'true') return;
      instances.push(new Slider(root));
    });
  }

  function refresh() {
    scan(document);
    instances.forEach(function (s) {
      if (s.track) s.evaluate();
    });
  }

  window.atnBoMSlider = {
    refresh: refresh,
    goTo: function (root, i) {
      for (var n = 0; n < instances.length; n++) {
        if (instances[n].root === root) instances[n].goTo(i);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
    refresh();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    instances = instances.filter(function (s) {
      return !event.target.contains(s.root);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target;
    var root = slide.closest ? slide.closest(ROOT_SELECTOR) : null;
    if (!root) return;
    for (var n = 0; n < instances.length; n++) {
      if (instances[n].root !== root) continue;
      var i = instances[n].slides.indexOf(slide);
      if (i > -1) instances[n].goTo(i);
    }
  });
})();